"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.advanced-reports.disabled': 'La función de informes avanzados no está disponible en su plan actual.',
};
